/**
 * @generated SignedSource<<415e43d83ecc54515349f7405fbaf0db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerformanceOverview_component$data = {
  readonly chart?: {
    readonly data: ReadonlyArray<{
      readonly benchmark: number | null | undefined;
      readonly date: string | null | undefined;
      readonly performance: number | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverviewChart_chart">;
  } | null | undefined;
  readonly disclaimer: string | null | undefined;
  readonly header: string | null | undefined;
  readonly id: string;
  readonly info: {
    readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverviewInfo_data" | "PerformanceOverviewNumbers_data">;
  } | null | undefined;
  readonly menu: {
    readonly currencySelectBox: {
      readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverviewCurrencySelection_currencySelection">;
    } | null | undefined;
    readonly currencySelectionHeader: string | null | undefined;
    readonly currencySelectionInfo: string | null | undefined;
    readonly currencySelectionSaveButtonText: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverviewMenu_menu">;
  } | null | undefined;
  readonly staticDisclaimer: string | null | undefined;
  readonly " $fragmentType": "PerformanceOverview_component";
};
export type PerformanceOverview_component$key = {
  readonly " $data"?: PerformanceOverview_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverview_component">;
};

import PerformanceOverviewRefetchQuery_graphql from './PerformanceOverviewRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "reportcurrency",
    "variableName": "reportcurrency"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "loadData"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "reportcurrency"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": PerformanceOverviewRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "PerformanceOverview_component",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disclaimer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "staticDisclaimer",
      "storageKey": null
    },
    {
      "condition": "loadData",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PerformanceOverviewChart",
          "kind": "LinkedField",
          "name": "chart",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": (v1/*: any*/),
              "concreteType": "PerformanceChartData",
              "kind": "LinkedField",
              "name": "data",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "performance",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "benchmark",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PerformanceOverviewChart_chart"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PerformanceOverviewInfo",
      "kind": "LinkedField",
      "name": "info",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PerformanceOverviewNumbers_data"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PerformanceOverviewInfo_data"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": "PerformanceOverviewMenu",
      "kind": "LinkedField",
      "name": "menu",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencySelectionSaveButtonText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencySelectionInfo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencySelectionHeader",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PerformanceOverviewMenu_menu"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SelectBox",
          "kind": "LinkedField",
          "name": "currencySelectBox",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PerformanceOverviewCurrencySelection_currencySelection"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PerformanceOverview",
  "abstractKey": null
};
})();

(node as any).hash = "95db4d2947721b6fcb7fd106739da736";

export default node;
